import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../helper/apiCall';
import ENDPOINTS from '../../constants/endpoints';

export const createWpInstance = createAsyncThunk(
  'wpConfig/createInstance',
  async (arg, thunkAPI) => {
    try {
      // Geriye dönük uyum: eskiden düz branchId geçiliyordu.
      const { branchId, placeId } = typeof arg === "object" && arg !== null ? arg : { branchId: arg };
      const placeQuery = placeId ? `&placeId=${placeId}` : "";
      const response = await client.post(`${ENDPOINTS.WP.CREATE_INSTANCE}?branchId=${branchId}${placeQuery}`, {}, {
        token: thunkAPI.getState().auth.token
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || error);
    }
  }
);

export const fetchWpInstanceStatus = createAsyncThunk(
  'wpConfig/fetchInstanceStatus',
  async (arg, thunkAPI) => {
    try {
      // Geriye dönük uyum: eskiden düz branchId geçiliyordu.
      const { branchId, placeId } = typeof arg === "object" && arg !== null ? arg : { branchId: arg };
      const placeQuery = placeId ? `&placeId=${placeId}` : "";
      const response = await client.get(`${ENDPOINTS.WP.INSTANCE_STATUS}?branchId=${branchId}${placeQuery}`, {
        token: thunkAPI.getState().auth.token
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || error);
    }
  }
);

export const sendWpMessage = createAsyncThunk(
  'wpConfig/sendMessage',
  async (payload, thunkAPI) => {
    try {
      // Bağlılık kontrolü (global uyarı amacıyla)
      const state = thunkAPI.getState();
      const instance = state.wpConfig.instance;
      const statusStr = instance?.status?.status || instance?.status || instance?.data?.status;
      const connected = (statusStr === 'connected') || instance?.connected === true || instance?.isConnected === true;
      if (!connected) {
        return thunkAPI.rejectWithValue('WP bağlı değil. Lütfen önce WP bağlayın.');
      }

      // branchId ve placeId'yi payload yoksa state'ten enjekte et
      const fallbackBranchId = state.branches?.selectedBranch?.id;
      const fallbackPlaceId = state.branches?.selectedPlace?.id;
      const body = {
        ...payload,
        branchId: payload?.branchId ?? fallbackBranchId,
        placeId: payload?.placeId ?? fallbackPlaceId
      };
      if (!body.branchId) {
        return thunkAPI.rejectWithValue('branchId bulunamadı. Lütfen bir branş seçiniz.');
      }

      const response = await client.post(
        ENDPOINTS.WP.SEND_MESSAGE,
        body,
        { token: state.auth.token }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || error);
    }
  }
);

const wpConfigSlice = createSlice({
  name: 'wpConfig',
  initialState: {
    status: 'idle',
    instance: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWpInstanceStatus.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchWpInstanceStatus.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.instance = action.payload;
      })
      .addCase(fetchWpInstanceStatus.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default wpConfigSlice.reducer; 